import React from "react";
import { Button } from 'react-bootstrap';
const CustomButton = ({ children, handleClick, variant, type, disabled, className }) => {

  return (
    <Button className={className} onClick={handleClick} variant={variant} type={type} disabled={disabled}>{children}</Button>
  )
}

export default CustomButton;